import { AuditTrailServiceApiAuditTrailServiceResourceActionsMonthlyRequest } from '@ariksa/audittrail/api';
import {
  ItemApiApproveRequestRequest,
  ItemApiListAllRequestsRequest,
  ItemApiListMyRequestsRequest,
  PageAccessRequestGetResponse,
} from '@ariksa/jit';
import {
  ItemApiDenyRequestRequest,
  ItemApiGetAssumeRolePolicyRequest,
  ResponseDenyRequestV1JitRequestsDenyRequestIdPost,
} from '@ariksa/jit/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { QueryAction } from 'services/types';
import { PagedQueryState } from 'services/utils/PagedQueryState';
import { QueryState } from 'services/utils/QueryState';

import { PageInfo } from 'components/Navigation';
import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

// The initial state of the Settings container
export const initialState: ContainerState = {
  jitRequests: PagedQueryState.init([]),
  myRequests: PagedQueryState.init([]),
  resourceActionPerHour: QueryState.init({}),
  resourceActionOnDay: QueryState.init({}),
  jitRequestAction: QueryState.init({}),
  policyDocument: QueryState.init(null),
};

const jitRequestsSlice = createSlice({
  name: 'jitRequests',
  initialState,
  reducers: {
    getJitRequests(
      state,
      action: QueryAction<
        PageAccessRequestGetResponse,
        ItemApiListAllRequestsRequest
      >,
    ) {
      state.jitRequests = PagedQueryState.next(state.jitRequests, action, {
        mapTotalCount: r => r.total || 0,
        mapData: r => r.items,
      });
    },

    updateJitRequestsPagination(state, action: PayloadAction<PageInfo>) {
      state.jitRequests.page.info = action.payload;
    },

    getMyRequests(
      state,
      action: QueryAction<
        PageAccessRequestGetResponse,
        ItemApiListMyRequestsRequest
      >,
    ) {
      state.myRequests = PagedQueryState.next(state.myRequests, action, {
        mapTotalCount: r => r.total || 0,
        mapData: r => r.items,
      });
    },

    updateMyRequestsPagination(state, action: PayloadAction<PageInfo>) {
      state.myRequests.page.info = action.payload;
    },

    getResourceActionPerHour(
      state,
      action: QueryAction<
        any,
        AuditTrailServiceApiAuditTrailServiceResourceActionsMonthlyRequest
      >,
    ) {
      state.resourceActionPerHour = QueryState.next(
        state.resourceActionPerHour,
        action,
      );
    },

    getResourceActionOnDay(state, action: QueryAction<any, any>) {
      state.resourceActionOnDay = QueryState.next(
        state.resourceActionOnDay,
        action,
      );
    },

    approveJitRequest(
      state,
      action: QueryAction<any, ItemApiApproveRequestRequest>,
    ) {
      state.jitRequestAction = QueryState.next(state.jitRequestAction, action);
    },
    denyJitRequest(
      state,
      action: QueryAction<
        ResponseDenyRequestV1JitRequestsDenyRequestIdPost,
        ItemApiDenyRequestRequest
      >,
    ) {
      state.jitRequestAction = QueryState.next(state.jitRequestAction, action);
    },

    getPolicyDocument(
      state,
      action: QueryAction<any, ItemApiGetAssumeRolePolicyRequest>,
    ) {
      state.policyDocument = QueryState.next(state.policyDocument, action);
    },
  },
});

export const { actions, reducer, name: sliceKey } = jitRequestsSlice;
